(function () {
(function() {
    "use strict";
    (function(s) {
        var _s_getAttribute, _s_getAttribute1;
        if (!s) {
            console.error("Password Toggle", "Could not find the current script");
            return;
        }
        var _s_getAttribute_split_map, _s_getAttribute_split_map1, _s_getAttribute2, _s_getAttribute3;
        const r = (_s_getAttribute_split_map = (_s_getAttribute = s.getAttribute("data-password-toggle-selector")) === null || _s_getAttribute === void 0 ? void 0 : _s_getAttribute.split(",").map((t)=>t.trim())) !== null && _s_getAttribute_split_map !== void 0 ? _s_getAttribute_split_map : [], o = (_s_getAttribute_split_map1 = (_s_getAttribute1 = s.getAttribute("data-password-input-selector")) === null || _s_getAttribute1 === void 0 ? void 0 : _s_getAttribute1.split(",").map((t)=>t.trim())) !== null && _s_getAttribute_split_map1 !== void 0 ? _s_getAttribute_split_map1 : [], i = (_s_getAttribute2 = s.getAttribute("data-password-hidden-icon-class")) !== null && _s_getAttribute2 !== void 0 ? _s_getAttribute2 : "", e = (_s_getAttribute3 = s.getAttribute("data-password-visible-icon-class")) !== null && _s_getAttribute3 !== void 0 ? _s_getAttribute3 : "";
        if (!r || !o) throw new Error("Missing required attributes");
        if (r.length !== o.length) throw new Error("The number of password toggle selectors must match the number of password input selectors");
        for(let t = 0; t < Math.min(r.length, o.length); t++)n(o[t], r[t], e, i);
    })(document.currentScript);
    function n(s, r, o, i) {
        const e = document.querySelector(s), t = document.querySelector(r);
        if (!t) throw new Error(`Missing toggle password element, with selector: ${r}`);
        t.addEventListener("click", a), e && (e.value || t.classList.add("hidden"), e.addEventListener("input", ()=>{
            var _window_formUtils;
            e.value && e.value.length > 0 ? t.classList.remove("hidden") : t.classList.add("hidden"), (_window_formUtils = window.formUtils) === null || _window_formUtils === void 0 ? void 0 : _window_formUtils.checkSubmitButtonState(e);
        }));
        function a() {
            e.type === "password" ? (e.type = "text", t === null || t === void 0 ? void 0 : t.classList.replace(o, i)) : (e.type = "password", t === null || t === void 0 ? void 0 : t.classList.replace(i, o));
        }
    }
})();



})();
//# sourceMappingURL=password-toggle.js.map
